import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';
import { patchLinks } from '~app/core/patchLinks';

class WildlifeDescription extends Component {

  render() {
    if (defined(this.props.selectedSpeciesContent)) {
      const htmlContent = this.props.selectedSpeciesContent.description;
      const link = this.props.selectedSpeciesContent.overview_url;

      return (
        <div className="WildlifeDescription">
          {this.renderContent(htmlContent, link)}
        </div>
      );
    }

    return null;
  }

  renderContent(htmlContent, link) {
    let content = [];
    if (defined(htmlContent)) {
      content = [
        this.renderTitle(),
        this.renderDescription(htmlContent),
        this.renderLink(link),
      ];
    }
    else {
      content = [
        this.renderTitle(),
        this.renderEmpty(),
      ];
    }

    return content.filter(jsx => defined(jsx));
  }

  renderTitle() {
    return (
      <p key="title" className="WildlifeDescription__title">
        Description
      </p>
    );
  }

  renderDescription(htmlContent) {
    return (
      <div
        key="description"
        className="WildlifeDescription__content"
        ref={elem => patchLinks(elem)}

        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
    );
  }

  renderLink(link) {
    if (defined(link)) {
      return (
        <p key="link" className="WildlifeDescription__learnMore">
          Interested in finding out more about this species? Visit the&nbsp;
          <a
            className="WildlifeDescription__link"
            href={link}
            target="_blank"
            rel="noopener"
          >
            Encyclopedia of Life
          </a>.
        </p>
      );
    }
  }

  renderEmpty() {
    return (
      <p key="empty" className="WildlifeDescription__empty">
        No description is available for this species.
      </p>
    );
  }
}

WildlifeDescription.propTypes = {
  selectedSpeciesContent: PropTypes.object,
};

export default WildlifeDescription;



// WEBPACK FOOTER //
// ./src/components/WildlifeDescription.js